const paidBenefits = {
  pro: [
    "Unlimited Applets",
    "Queries and filters",
    "AI and other exclusive services",
    "Increased rate limits and speeds",
    "Multi-action Applets",
    "Prioritized customer support",
  ],

  intermediate_pro: [
    "20 Applets",
    "Faster Applet speeds",
    "Multi-action Applets",
    "Increased rate limits",
    "Exclusive Pro services",
    "Customer support",
  ],

  credits_starter: [
    "Change me",
    "Change me",
    "Change me"
  ],

  credits_pro: [
    "Change me",
    "Change me",
    "Change me"
  ],

  credits_pro_plus: [
    "Change me",
    "Change me",
    "Change me"
  ],
}

export default paidBenefits
